import { Plus } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { LicenseManagement } from "@/components/dashboard/superadmin/LicenseManagement"
import { Page, PageHeader } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"
import { Button } from "@/components/ui/button"

const LicensesPage = () => {
  const navigate = useNavigate()
  return (
    <SuperAdminLayout>
      <Page>
        <PageHeader
          title="Licenças"
          description="Chaves dos sistemas desktop. Toda chave pertence a uma empresa e fica no histórico, mesmo arquivada."
          actions={<Button className="h-9 gap-1.5" onClick={() => navigate("/superadmin/licencas?nova=1")}><Plus className="h-4 w-4" />Nova licença</Button>}
        />
        <LicenseManagement />
      </Page>
    </SuperAdminLayout>
  )
}

export default LicensesPage
